import React, { useEffect, useState } from 'react';
import useInterval from '@use-it/interval';
import styled, { css } from 'styled-components';

const Container = styled.div`
  background: #111111;
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: opacity 1s;

  ${props =>
    !props.loading &&
    css`
      opacity: 0;
    `};
`;

const Text = styled.div`
  font-family: DINCondensed-Regular;
  font-size: 1.5em;
  letter-spacing: 0.1rem;
  width: 80%;
  max-width: 30rem;
`;

const ProgressContainer = styled.div`
  align-items: center;
  display: flex;
  margin-top: 0.5em;
  max-width: 30rem;
  width: 80%;
`;

const ProgressLeft = styled.div`
  background: #ffffff;
  height: 36px;
  position: relative;
  width: 12px;

  &::after {
    background: #111111;
    content: '';
    display: block;
    height: 28px;
    position: absolute;
    right: 0;
    top: 4px;
    width: 8px;
  }
`;

const ProgressRight = styled.div`
  background: #ffffff;
  height: 36px;
  position: relative;
  width: 12px;

  &::after {
    background: #111111;
    content: '';
    display: block;
    height: 28px;
    left: 0;
    position: absolute;
    top: 4px;
    width: 8px;
  }
`;

const Progress = styled.div`
  flex: 1 0 auto;
  height: 16px;
  overflow: hidden;
  position: relative;

  &::before {
    background: ${props => props.theme.primary};
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    position: absolute;
    right: ${props => `${100 - props.progress}%`};
    top: 0;
    transition: right 0.1s;
  }
`;

const Splash = ({ loading, nImages, nLoadedImages }) => {
  const [progress, setProgress] = useState(0);
  const [display, setDisplay] = useState(true);

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => setDisplay(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  // TODO: clearInterval
  useInterval(() => {
    setProgress(val => {
      const max = Math.floor((100 * (nLoadedImages + 1)) / nImages);
      return Math.min(val + Math.round(Math.random() * 5 + 1), max);
    });
  }, 250);

  return display ? (
    <Container loading={Number(loading)}>
      <Text>Initializing...</Text>
      <ProgressContainer>
        <ProgressLeft />
        <Progress progress={progress} />
        <ProgressRight />
      </ProgressContainer>
    </Container>
  ) : null;
};

export default Splash;
